/**
 * Session-only cache (tab survives refresh) — same calendar day + same email.
 * Cleared on logout via clearAllAppSessionCaches().
 */

const APP_SESSION_KEY = 'app_session_cache_v1';
const HR_TREND_KEY = 'hr_dashboard_trend_counts_v1';
const HR_MONTHLY_ATTENDANCE_KEY = 'hr_monthly_attendance_v1';

export function readAppSessionCache(email) {
  if (!email) return null;
  try {
    const raw = sessionStorage.getItem(APP_SESSION_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (o.email !== email) return null;
    const today = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; })();
    if (o.date !== today) return null;
    return o.data;
  } catch {
    return null;
  }
}

export function writeAppSessionCache(email, data) {
  if (!email) return;
  try {
    const today = (() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; })();
    sessionStorage.setItem(
      APP_SESSION_KEY,
      JSON.stringify({ email, date: today, data, ts: Date.now() })
    );
  } catch {
    /* quota / private mode */
  }
}

export function readHrTrendCache(startStr, endStr) {
  try {
    const raw = sessionStorage.getItem(HR_TREND_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (o.start !== startStr || o.end !== endStr) return null;
    if (Date.now() - o.ts > 15 * 60 * 1000) return null;
    return o.countsByDate;
  } catch {
    return null;
  }
}

export function writeHrTrendCache(startStr, endStr, countsByDate) {
  try {
    sessionStorage.setItem(
      HR_TREND_KEY,
      JSON.stringify({ start: startStr, end: endStr, countsByDate, ts: Date.now() })
    );
  } catch {
    /* quota */
  }
}

export function readHrMonthlyAttendanceCache(startStr, endStr) {
  try {
    const raw = sessionStorage.getItem(HR_MONTHLY_ATTENDANCE_KEY);
    if (!raw) return null;
    const entries = JSON.parse(raw);
    const key = `${startStr}_${endStr}`;
    const entry = entries[key];
    if (!entry) return null;
    if (Date.now() - entry.ts > 15 * 60 * 1000) return null;
    return entry.rows;
  } catch {
    return null;
  }
}

export function writeHrMonthlyAttendanceCache(startStr, endStr, rows) {
  try {
    const raw = sessionStorage.getItem(HR_MONTHLY_ATTENDANCE_KEY);
    const entries = raw ? JSON.parse(raw) : {};
    const key = `${startStr}_${endStr}`;
    entries[key] = { rows, ts: Date.now() };
    sessionStorage.setItem(HR_MONTHLY_ATTENDANCE_KEY, JSON.stringify(entries));
  } catch {
    /* quota */
  }
}

export function clearAllAppSessionCaches() {
  try {
    sessionStorage.removeItem(APP_SESSION_KEY);
    sessionStorage.removeItem(HR_TREND_KEY);
    sessionStorage.removeItem(HR_MONTHLY_ATTENDANCE_KEY);
  } catch {
    /* */
  }
}
